import React from 'react'

export const FeatureBox = ({ icon, title, description }) => (
  <div className="col-md-6  mt-4 mt-md-0">
    <div className="icon-box">
      <i className={icon} />
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  </div>
)
